export const ACTIONS = {
  // GLOBAL MACHINE ACTIONS
  MACHINE_RESET: 'MACHINE_RESET',

  // CONTEXT GLOBAL
  CONTEXT_RESET: 'CONTEXT_RESET',
  CONTEXT_REHYDRATE: 'CONTEXT_REHYDRATE',

  // CONTEXT ADDRESS
  CONTEXT_ADDRESS_RESET: 'CONTEXT_ADDRESS_RESET',
  CONTEXT_ADDRESS_UPDATE: 'CONTEXT_ADDRESS_UPDATE',
  CONTEXT_ADDRESS_OVERWRITE: 'CONTEXT_ADDRESS_OVERWRITE',

  // CONTEXT SHIPPING METHOD
  CONTEXT_SHIPPING_METHOD_RESET: 'CONTEXT_SHIPPING_METHOD_RESET',
  CONTEXT_SHIPPING_METHOD_UPDATE: 'CONTEXT_SHIPPING_METHOD_UPDATE',
  CONTEXT_SHIPPING_METHOD_OVERWRITE: 'CONTEXT_SHIPPING_METHOD_OVERWRITE',

  // CONTEXT ELIGIBLE SHIPPING METHOD
  CONTEXT_ELIGIBLE_SHIPPING_METHOD_RESET:
    'CONTEXT_ELIGIBLE_SHIPPING_METHOD_RESET',
  CONTEXT_ELIGIBLE_SHIPPING_METHOD_UPDATE:
    'CONTEXT_ELIGIBLE_SHIPPING_METHOD_UPDATE',

  // ASYNC SERVICE CALL ACTIONS
  ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS:
    'ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS',
  ASYNC_SAVE_CUSTOMER_DATA: 'ASYNC_SAVE_CUSTOMER_DATA',

  // GENERIC CALLBACK ACTIONS
  ON_SERVICE_SUCCESS: 'ON_SERVICE_SUCCESS',
  ON_SERVICE_ERROR: 'ON_SERVICE_ERROR',
};
